interface CustomErrorFields {
  id: string;
  defaultMessage: string;
}

class CustomError extends Error {
  public id: string;

  public defaultMessage: string;

  constructor({ id, defaultMessage }: CustomErrorFields) {
    super(defaultMessage);
    this.name = "CustomError";
    this.id = id;
    this.defaultMessage = defaultMessage;
  }
}

export default CustomError;
